import isNil from 'lodash.isnil'
import {
  GetRecordEmailPreviewDataQuery,
  GetRecordEmailPreviewDataQueryVariables,
} from 'types/graphql'

import { QueryKey, useQuery, UseQueryOptions } from 'src/utils/queryClient'

const GetRecordEmailPreviewData = gql`
  query GetRecordEmailPreviewDataQuery($recordId: Int!) {
    recordById(id: $recordId) {
      id
      expirationDate
      formattedName
    }
  }
`
export const useRecordEmailPreviewDataQuery = (
  recordId: number | undefined,
  options?: UseQueryOptions<GetRecordEmailPreviewDataQuery, GetRecordEmailPreviewDataQueryVariables>
) => {
  return useQuery<GetRecordEmailPreviewDataQuery, GetRecordEmailPreviewDataQueryVariables>({
    queryKey: [QueryKey.RecordEmailPreviewData, recordId],
    queryDocument: GetRecordEmailPreviewData,
    variables: {
      recordId: recordId ?? -1,
    },
    ...options,
    enabled: (isNil(options?.enabled) || options.enabled) && !!recordId,
  })
}
